import React from 'react';
import { Lightbulb, Mic2, Users, Rocket, Globe, Zap, Target, Cpu } from 'lucide-react';

const services = [
  { title: "Leadership", icon: Users, desc: "Driving organizational excellence from the top down." },
  { title: "Transformation", icon: Rocket, desc: "Navigating the shift from current state to future readiness." },
  { title: "Future of Work", icon: Globe, desc: "Adapting to the evolving landscape of global workforce dynamics." },
  { title: "Heritage", icon: Lightbulb, desc: "Leveraging legacy strengths to fuel modern innovation." },
  { title: "Innovation", icon: Zap, desc: "Breaking boundaries to create new value propositions." },
  { title: "Marketing", icon: Target, desc: "Connecting with audiences through authentic storytelling." },
  { title: "Sales", icon: Target, desc: "Strategic approaches to revenue growth and client partnerships." },
  { title: "Technology", icon: Cpu, desc: "Demystifying tech trends to drive business impact." },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-[#1a1c1b] relative">
      <div className="container-custom mx-auto px-6">
        <div className="mb-16">
          <h2 className="heading-2 mb-4">Keynote Topics</h2>
          <div className="h-1 w-20 bg-[var(--brand-primary)]"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group p-8 border border-[var(--border-medium)] hover:border-[var(--brand-primary)] hover:bg-[#302f2c] transition-all duration-300 rounded-lg">
              <service.icon className="w-10 h-10 text-[var(--brand-primary)] mb-6" />
              <h3 className="heading-6 text-white uppercase mb-3">{service.title}</h3>
              <p className="body-medium text-gray-400">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
